import { render, staticRenderFns } from "./S3AvatarPicker.vue?vue&type=template&id=50fb33de&scoped=true&"
import script from "./S3AvatarPicker.vue?vue&type=script&lang=js&"
export * from "./S3AvatarPicker.vue?vue&type=script&lang=js&"
import style0 from "./S3AvatarPicker.vue?vue&type=style&index=0&id=50fb33de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb33de",
  null
  
)

export default component.exports